import React  from 'react';
import './App.css';
import './Report.css';
import ReportLang from './ReportLang.json';
import ReportMainToolbar from './ReportMainToolbar.js';

import ReportOccupancy from './ReportOccupancy.js';
import ReportOccupancyProgress from './ReportOccupancyProgress.js';
import ReportBookSource from './ReportBookSource.js';
import ReportBillList from './ReportBillList.js';
import ReportExpenses from './ReportExpenses.js';
import ReportAdria from './ReportAdria.js';
import ReportAI from './ReportAI.js';

class ReportMain extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			tab: "",
			dashboardID: 0,
		};
		
		this.setTab = this.setTab.bind(this);
		this.renderOccupancy = this.renderOccupancy.bind(this);
		this.renderAgencies = this.renderAgencies.bind(this);
		this.renderBills = this.renderBills.bind(this);
		this.renderExpenses = this.renderExpenses.bind(this);
		this.renderTab = this.renderTab.bind(this);
	}

	componentDidMount() {

		var dashboardID = this.props.dashboardID;
		if (dashboardID > 0) {
			//this.serverGetReportVariableList(dashboardID, currentYear, currentMonth);
		}
		
		this.setState({
			dashboardID: dashboardID
		});
	}
	
	componentDidUpdate() {

		var tab = this.state.tab;
		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		if (tab === "") {
			if (dashboardAppUserType > 0) {
				var toolbarVariableNameArray = this.getToolbarVariableNameArray();
				if (toolbarVariableNameArray.length > 0) {
					this.setState({tab: toolbarVariableNameArray[0]});
				}
			}
		}
		

		var dashboardID1 = this.state.dashboardID;
		var dashboardID2 = this.props.dashboardID;
		
		if (dashboardID1 === dashboardID2) {
			return;
		}

		if (dashboardID2 > 0) {
			//this.serverGetReportVariableList(dashboardID2, selectedYear, selectedMonth);
		}
		
		this.setState({
			dashboardID: dashboardID2
		});
	}

	getToolbarVariableNameArray() {

		var variableNameArray = [];
		
		var dashboardID = this.props.dashboardID;

		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		var showOccupancyYN = true;
		var showRoomsYN = true;
		var showAgenciesYN = false;
		var showBillsYN = false;
		var showExpensesYN = false;
		var showAIYN = true;

		if (dashboardAppUserType === 99) {
			showBillsYN = true;
		}

		if (dashboardAppUserType >= 100) {
			showBillsYN = true;
		}
		
		if (dashboardAppUserType === 1) {
			if ((dashboardUserType === 3) || (dashboardUserType === 102)) {
				showBillsYN = true;
			}
			if (dashboardUserType === 1001) {
				showOccupancyYN = false;
				showRoomsYN = false;
				showAIYN = false;
			}
			if ((dashboardUserType === 1002) || (dashboardUserType === 1003) || (dashboardUserType === 1004)) {
				showBillsYN = true;
			}
		}
		
		var showAdriaYN = false;
		if (dashboardID === 1) {
			showAdriaYN = true;
		}
		
		/*if ((dashboardAppUserType === 100) || (dashboardAppUserType === 100)) {
			showBillsYN = true;
		}*/

		var showPriceYN = false;
		if (dashboardAppUserType === 99) {
			showPriceYN = true;
		}
		if (dashboardAppUserType >= 100) {
			showPriceYN = true;
		}
		if (dashboardAppUserType === 1) {
			if (dashboardUserType < 1000) {
					showPriceYN = true;
			}
		}

		if (showPriceYN) {
			if ((dashboardID === 1) || (dashboardID === 2)) {
				showAgenciesYN = true;
			}
		}
		
		if (showOccupancyYN) {
			variableNameArray.push("occupancy");
		}
		if (showPriceYN) {
			variableNameArray.push("roomrevenue");
			variableNameArray.push("rooms");
			variableNameArray.push("roomprice");
			variableNameArray.push("progress");
		} else {
			if (showRoomsYN) {
				variableNameArray.push("rooms");
			}
		}
		if (showAgenciesYN) {
			variableNameArray.push("agencies");
		}
		if (showBillsYN) {
			variableNameArray.push("bills");
		}
		if (showExpensesYN) {
			variableNameArray.push("expenses");
		}
		if (showAdriaYN) {
			variableNameArray.push("adria");
		}
		if (showAIYN) {
			variableNameArray.push("ai");
		}

		return variableNameArray;
	}

	setTab(tab) {
		this.setState({
			tab: tab,
		});
	}
	
	renderOccupancy(tab) {
		return (
			<ReportOccupancy
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				tab={tab}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getMonthStringShort={this.props.getMonthStringShort}
			/>
		);
	}
	
	renderProgress() {
		return (
			<ReportOccupancyProgress
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getMonthStringShort={this.props.getMonthStringShort}
			/>
		);
	}
	
	renderAgencies() {
		return (
			<ReportBookSource
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				email={this.props.email}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				selectedYear={this.props.selectedYear}
				language={this.props.language}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getTwoDigits={this.props.getTwoDigits}
				showToast={this.props.showToast}
				setSelectedYear={this.props.setSelectedYear}
			/>
		);
	}
	
	renderBills() {
		return (
			<ReportBillList
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				dashboardAppUserType={this.props.dashboardAppUserType}
				dashboardUserType={this.props.dashboardUserType}
				email={this.props.email}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				selectedYear={this.props.selectedYear}
				language={this.props.language}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
				getTwoDigits={this.props.getTwoDigits}
				showToast={this.props.showToast}
				setSelectedYear={this.props.setSelectedYear}
			/>
		);
	}
	
	renderAdria() {
		return (
			<ReportAdria
				userID={this.props.userID}
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				setTab={this.setTab}
				getLang={this.props.getLang}
				showToast={this.props.showToast}
				getTwoDigits={this.props.getTwoDigits}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
			/>
		);
	}
	
	renderAI() {
		return (
			<ReportAI
				userID={this.props.userID}
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
			/>
		);
	}
	
	renderExpenses() {
		return (
			<ReportExpenses
				calcHelpersObj={this.props.calcHelpersObj}
				baseURLAPI={this.props.baseURLAPI}
				dashboardID={this.props.dashboardID}
				dashboardName={this.props.dashboardName}
				setTab={this.setTab}
				getLang={this.props.getLang}
				getEURString={this.props.getEURString}
				getDateTimeStringFromUnixTimeSec={this.props.getDateTimeStringFromUnixTimeSec}
				getMonthString={this.props.getMonthString}
			/>
		);
	}

	renderTab() {
		
		var tab = this.state.tab;
		
		if ((tab === "occupancy") || (tab === "roomrevenue") || (tab === "rooms") || (tab === "roomprice")) {
			return this.renderOccupancy(tab);
		}
		
		if (tab === "progress") {
			return this.renderProgress();
		}
		
		if (tab === "agencies") {
			return this.renderAgencies();
		}
		
		if (tab === "bills") {
			return this.renderBills();
		}
		
		if (tab === "adria") {
			return this.renderAdria();
		}
		
		if (tab === "ai") {
			return this.renderAI();
		}
		
		if (tab === "expenses") {
			return this.renderExpenses();
		}
	}
	
	render() {
		
		var toolbarVariableNameArray = this.getToolbarVariableNameArray();
		
		return (
			<div className="ReportMainTopContainer">
				<ReportMainToolbar
					dashboardAppUserType={this.props.dashboardAppUserType}
					dashboardUserType={this.props.dashboardUserType}
					dashboardID={this.props.dashboardID}
					dashboardName={this.props.dashboardName}
					toolbarVariableNameArray={toolbarVariableNameArray}
					dashboardVariableListJsonObj={this.state.dashboardVariableListJsonObj}
					tab={this.state.tab}
					setTab={this.setTab}
					getLang={this.props.getLang}
				/>
				{this.renderTab()}
			</div>
		);
	}
}

export default ReportMain;

